module.exports = {
    "services": [
        {
            "label": "Teams",
            "slug": "asd"
        },
        {
            "label": "Teams",
            "slug": "/"
        },
        {
            "label": "Teams",
            "slug": "/asd"
        },
        {
            "label": "Teams",
            "slug": "/"
        }
    ],
    "sector": [
        {
            "label": "Teams",
            "slug": "/"
        },
        {
            "label": "Teams",
            "slug": "/"
        }
    ],
    "blog": [
        {
            "label": "Teams",
            "slug": "/"
        },
        {
            "label": "Teams",
            "slug": "/"
        }
    ],
    "aboutUs": [
        {
            "label": "Teams",
            "slug": "/"
        },
        {
            "label": "Teams",
            "slug": "/"
        }
    ],
    "contact": [
        {
            "label": "Teams",
            "slug": "/"
        },
        {
            "label": "Teams",
            "slug": "/"
        }
    ],
}